import gps from './gps';
import simcards from './simcards';
import devices from './devices';

export default function* () {
    yield* [
        ...gps,
        ...simcards,
        ...devices
    ];
}